<template>
  <model-form
    ref="modelForm"
    :model="voucherPackage"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-start">
        <model-form-input
          field="name"
          class="col"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          autofocus
        />
        <q-input
          :model-value="voucherPackage.price"
          class="col"
          label="Voucher Package Price"
          :prefix="currentCircuit.localeCurrencySymbol"
          disable
        />
      </div>
      <div class="row q-col-gutter-sm items-start">
        <model-form-input
          field="description"
          class="col"
          label="Description"
        />
      </div>
      <div class="row q-col-gutter-y-sm items-start">
        <model-form-toggle
          field="taxable"
          class="col-4 q-pb-md"
          :label="$t('pricing.taxable')"
        />
        <q-select
          v-if="voucherPackage.taxable"
          v-model="voucherPackage.taxIds"
          class="col-8"
          :label="$t('pricing.tax')"
          stack-label
          :options="taxes.data"
          option-value="id"
          map-options
          emit-value
          multiple
          clearable
          :disable="voucherPackage.isTranslation"
          :rules="[val => (!!val && val.length > 0) || 'Field is required']"
          bottom-slots
        >
          <template #selected-item="scope">
            <q-chip
              v-if="scope.opt.name"
              removable
              dense
              :tabindex="scope.tabindex"
              :label="scope.opt.name"
              @remove="scope.removeAtIndex(scope.index)"
            />
          </template>
          <template #option="scope">
            <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents"
            >
              <q-item-section>
                {{ scope.opt.name }}
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div class="row q-col-gutter-md justify-around items-start q-mb-lg">
        <model-form-image-uploader
          field="image"
          class="col-6"
          img-url-property="imageUrl"
        />
      </div>
      <div class="row q-col-gutter-y-sm items-start">
        <q-select
          v-model="voucherPackage.voucherTypeIds"
          label="Voucher Types"
          outlined
          class="col"
          multiple
          clearable
          :disable="voucherPackage.isTranslation"
          :options="$_.sortBy(voucherTypes.data, voucherType => $_.toLower(voucherType.name))"
          stack-label
          bottom-slots
          map-options
          emit-value
          option-value="id"
          menu-anchor="bottom left"
          @add="option => addVoucherType(option)"
          @remove="option => removeVoucherType(option)"
        >
          <template #selected-item="scope">
            <q-chip
              v-if="scope.opt.name"
              removable
              dense
              :tabindex="scope.tabindex"
              :label="scope.opt.name"
              @remove="scope.removeAtIndex(scope.index)"
            />
          </template>
          <template #option="scope">
            <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents"
            >
              <q-item-section>
                {{ scope.opt.name }}
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div
        v-for="voucherType in voucherPackage.voucherTypes.data"
        :key="voucherType.id"
        class="row q-col-gutter-sm items-start"
      >
        <q-input
          v-model.number="voucherPackage.voucherTypeOptions[voucherType.id].count"
          class="col-6"
          type="number"
          :label="'Number of ' + voucherType.name"
          :readonly="voucherPackage.isTranslation"
          :rules="[val => !!val || val > 0 || 'Field is required']"
        />
        <q-select
          v-model="voucherPackage.voucherTypeOptions[voucherType.id].card_type"
          class="col-6 q-pr-none"
          :label="voucherType.name + ' Card Type'"
          :options="$mh.asOptions(VOUCHER_PACKAGE_CARD_TYPES.ALL)"
          emit-value
          :display-value="$_.startCase(voucherPackage.voucherTypeOptions[voucherType.id].card_type)"
          :readonly="voucherPackage.isTranslation"
          :rules="[
            val => !!val || 'Field is required',
            val => val !== VOUCHER_PACKAGE_CARD_TYPES.CONSECUTIVE || voucherType.barcodeOptions.card_uid_increment_length > 0 || 'Voucher Type Barcode Must Have Increment Length Set'
          ]"
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import { VOUCHER_PACKAGE_CARD_TYPES } from 'src/models/voucher/VoucherPackage'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import { reactive } from 'vue'

export default {
  name: 'VoucherPackageForm',
  components: {
    ModelForm
  },
  configuration: ['voucherTypes', 'currentCircuit', 'taxes'],
  models: {
    voucherPackage: {
      taxes: 'default',
      voucherTypes: 'default'
    }
  },
  created () {
    _.extend(this, { VOUCHER_PACKAGE_CARD_TYPES })
  },
  methods: {
    addVoucherType (option) {
      this.voucherPackage.voucherTypeOptions[option.value] ||= reactive({
        count: 1,
        card_type: 'shared'
      })
      this.voucherPackage.voucherTypeIds ||= []
      this.voucherPackage.voucherTypeIds.push(option.value)
    },
    removeVoucherType (option) {
      this.voucherPackage.voucherTypeIds = _.remove(this.voucherPackage.voucherTypeIds, existingVoucherTypeId => existingVoucherTypeId === option.value)
      delete this.voucherPackage.voucherTypeOptions[option.value]
    }
  }
}

</script>
